import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export const CardsStarIcon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
    >
      <path d="M12.2241 12.5L14.4991 11.125L16.7741 12.5L16.1741 9.9L18.1741 8.175L15.5491 7.95L14.4991 5.5L13.4491 7.95L10.8241 8.175L12.8241 9.9L12.2241 12.5ZM12.6991 19H18.2991C18.1824 19.4333 17.9824 19.7833 17.6991 20.05C17.4158 20.3167 17.0491 20.4833 16.5991 20.55L5.69909 21.875C5.14909 21.9583 4.65326 21.8292 4.21159 21.4875C3.76992 21.1458 3.51576 20.7 3.44909 20.15L2.12409 9.225C2.05742 8.675 2.19076 8.18333 2.52409 7.75C2.85742 7.31667 3.29909 7.06667 3.84909 7L4.99909 6.85V8.85L4.09909 8.975L5.44909 19.9L12.6991 19ZM8.99909 17C8.44909 17 7.97826 16.8042 7.58659 16.4125C7.19492 16.0208 6.99909 15.55 6.99909 15V4C6.99909 3.45 7.19492 2.97917 7.58659 2.5875C7.97826 2.19583 8.44909 2 8.99909 2H19.9991C20.5491 2 21.0199 2.19583 21.4116 2.5875C21.8033 2.97917 21.9991 3.45 21.9991 4V15C21.9991 15.55 21.8033 16.0208 21.4116 16.4125C21.0199 16.8042 20.5491 17 19.9991 17H8.99909ZM8.99909 15H19.9991V4H8.99909V15Z" />
    </SvgIcon>
  );
};
